import type { Action } from 'redux';

export const ROLLBACK_UNSAVED_CHANGES = 'ROLLBACK_UNSAVED_CHANGES';
export const rollbackUnsavedChanges = (): RollbackUnsavedChangesAction => {
  return {
    type: ROLLBACK_UNSAVED_CHANGES,
  };
};

export type RollbackUnsavedChangesAction = Action<typeof ROLLBACK_UNSAVED_CHANGES>;
